import { Service } from '@angular/core';
import { State } from '@ngxs/store';
import { CollectionDataServiceBase } from '@portal-core/data/collection/services/collection-data.service.base';
import { CollectionStateSelectors } from '@portal-core/data/collection/services/collection-state-selectors.decorator';
import { CollectionStateBase } from '@portal-core/data/collection/services/collection-state.base';
import { Team } from '@portal-core/teams/models/team.model';

@CollectionStateSelectors({
  stateType: TeamsState
})
@State<TeamsState>({
  name: TeamsState.source
})
@Service({ autoProvided: false })
export class TeamsState extends CollectionStateBase {
  static override source = 'Teams';
  getSource(): string {
    return TeamsState.source;
  }
}
@Service()
export class TeamsDataService extends CollectionDataServiceBase<Team> {
  protected readonly stateType = TeamsState;
}
